import { Select } from '@radix-ui/themes';
import { OptionDef } from 'interfaces/options';
import { useMemo } from 'react';

export const ActionSelect = (props: {
  options: OptionDef[];
  onValueChange: (v: string) => void;
}) => {
  const visibleOptions = useMemo(
    () => props.options.filter((o) => !o.hidden),
    [props.options]
  );

  return (
    <Select.Root value="" onValueChange={props.onValueChange}>
      <Select.Trigger placeholder="Actions" />
      <Select.Content>
        <Select.Item value="--NOTHING--">Select...</Select.Item>
        {visibleOptions.map((o, i) => (
          <Select.Item key={`o-${i}`} value={o.value}>
            {o.label}
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  );
};
